export const SchemeAttributeList = [
  {
    names: ['ANZ Certification Scheme'],
    attributes: [
      {
        attributeName: 'certificate_testingLaboratory',
        fieldType: 'list',
        editable: true,
      },
      {
        attributeName: 'certificate_uLOffice',
        fieldType: 'list',
        editable: true,
      },
      {
        attributeName: 'certificate_testReportScope',
        fieldType: 'list',
        editable: true,
      },
      {
        attributeName: 'certificate_testReportCTF',
        fieldType: 'list',
        editable: true,
      },
      {
        attributeName: 'questions_firstReviewMainFinding',
        fieldType: 'list',
        editable: true,
      },
    ],
  },
  {
    names: [
      'IECEE CB Scheme',
      'IECEE CB Scheme Aspect',
      'IECEE CB Scheme Component',
      'IECEE CB Scheme Cyber',
    ],
    attributes: [
      {
        attributeName: 'certificate_projectHandlername',
        fieldType: 'list',
        editable: true,
      },
      {
        attributeName: 'certificate_approver_Reviewername',
        fieldType: 'list',
        editable: true,
      },
    ],
  },
]
